import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TrendingUp, Zap, ShieldCheck, RefreshCw, LockOpen } from "lucide-react";
const benefits = [{
  title: "Better results",
  description: "Consistent care compounds over time, leading to more profound and lasting improvements in your overall well-being.",
  icon: TrendingUp
}, {
  title: "Improved energy + performance",
  description: "Regular treatments help maintain optimal nutrient levels, keeping your energy high and performance at its peak.",
  icon: Zap
}, {
  title: "Long-term health optimization",
  description: "Shift from reactive to proactive health management with a structured, ongoing wellness protocol designed for you.",
  icon: ShieldCheck
}];
const trustFeatures = [{
  title: "Service Rollover",
  description: "Unused services automatically roll over to the next month. You never lose what you pay for.",
  icon: RefreshCw
}, {
  title: "No Long-Term Contracts",
  description: "Cancel anytime. We believe in earning your loyalty through exceptional results, not lock-ins.",
  icon: LockOpen
}];
export default function WhyMembershipWorks() {
  return <section id="whymembershipworks" className="bg-card py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="font-default text-4xl md:text-5xl font-semibold text-foreground mb-6 tracking-tight">
            Why Membership Works
          </h2>
          <p className="text-xl text-muted-foreground font-default">
            Wellness isn't occasional—it's consistent.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {benefits.map((benefit, i) => <Card key={i} data-index={i} className="bg-background border-border shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-full bg-secondary flex items-center justify-center mb-4 text-foreground">
                  <benefit.icon className="size-6" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-xl text-foreground">
                  {benefit.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground font-default leading-relaxed">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="max-w-4xl mx-auto bg-background rounded-2xl p-8 md:p-12 shadow-sm border border-border mb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
            {trustFeatures.map((feature, i) => <div key={i} data-index={i} className="flex gap-5">
                <div className="shrink-0 mt-1 text-foreground">
                  <feature.icon className="size-6" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-default text-lg font-semibold text-foreground mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="text-center">
          <Button asChild size="lg" className="rounded-full px-10 py-7 text-lg font-default shadow-md hover:shadow-lg transition-all bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90">
            <Link to="/MembershipsPage">Join Membership</Link>
          </Button>
        </div>
      </div>
    </section>;
}